// extracted by mini-css-extract-plugin
export var smallSpinner = "_x8-0";